/**
 * Utility to create a stylesheet with superpowers
 * Compatible with React Native StyleSheet.create
 * @param stylesheet - The stylesheet with superpowers to be used
 */
export const createStyleSheet = stylesheet => stylesheet;
//# sourceMappingURL=createStyleSheet.js.map